import { useTranslation } from "react-i18next";
import { JsonLd } from "@/src/common/components/json-ld";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { buildHomeStructuredData } from "@/src/common/constants/structured-data";
import { AiInsightsTeaser } from "@/src/home/components/ai-insights-teaser";
import { BrandedAppShowcase } from "@/src/home/components/branded-app-showcase";
import { FinalCta } from "@/src/home/components/final-cta";
import { GettingStartedSection } from "@/src/home/components/getting-started-section";
import { HeroSection } from "@/src/home/components/hero-section";
import { InteractiveDemoSection } from "@/src/home/components/interactive-demo-section";
import { PricingTeaser } from "@/src/home/components/pricing-teaser";
import { TrustedByBar } from "@/src/home/components/trusted-by-bar";
import { UnifiedPlatformSection } from "@/src/home/components/unified-platform-section";

export function HomePage() {
	const { t } = useTranslation("home");
	const description = t("meta.description");
	return (
		<>
			<PageHelmet title={t("meta.title")} description={description} />
			<JsonLd data={buildHomeStructuredData(description)} />
			<HeroSection />
			<TrustedByBar />
			<InteractiveDemoSection />
			<UnifiedPlatformSection />
			<BrandedAppShowcase />
			<AiInsightsTeaser />
			<GettingStartedSection />
			<PricingTeaser />
			<FinalCta />
		</>
	);
}
